var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"oxy-class-selector-breakpoint"},[_c('Icon',{attrs:{"icon":_vm.breakpointIcon,"rotate":_vm.breakpointIconRotation,"size":12}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }